import { Switch } from "@/components/ui/switch";
import { useLang } from "@/lib/i18n";

const PRESETS = [2, 3, 4, 5, 8, 11];

export const SizeFields = ({ type, width, height, onChange, lock, setLock, ratio, error }) => {
  const { t } = useLang();
  const fmt = (n) => String(Math.round(n * 100) / 100);

  const setW = (v) => {
    const n = parseFloat(v);
    onChange(v, lock && ratio && n > 0 ? fmt(n / ratio) : height);
  };
  const setH = (v) => {
    const n = parseFloat(v);
    onChange(lock && ratio && n > 0 ? fmt(n * ratio) : width, v);
  };
  const preset = (p) => {
    if (!ratio) return onChange(String(p), String(p));
    if (ratio >= 1) onChange(String(p), fmt(p / ratio));
    else onChange(fmt(p * ratio), String(p));
  };
  const longest = Math.max(parseFloat(width) || 0, parseFloat(height) || 0);

  return (
    <div>
      <div className="grid grid-cols-2 gap-3">
        <label>
          <span className="label">{t("builder.width")} (in)</span>
          <input type="number" min="0.5" step="0.1" inputMode="decimal" value={width} onChange={(e) => setW(e.target.value)} className="field font-mono-num" data-testid="width-input" />
        </label>
        <label>
          <span className="label">{t("builder.height")} (in)</span>
          <input type="number" min="0.5" step="0.1" inputMode="decimal" value={height} onChange={(e) => setH(e.target.value)} className="field font-mono-num" data-testid="height-input" />
        </label>
      </div>
      <p className="label mt-4">{t("builder.presets")}</p>
      <div className="flex flex-wrap gap-2">
        {PRESETS.map((p) => (
          <button key={p} type="button" onClick={() => preset(p)} data-testid={`preset-size-${p}inch`}
            className={`rounded-md border px-3.5 py-1.5 font-mono-num text-sm font-bold transition-colors ${longest === p ? "border-gold bg-gold text-ink" : "border-white/15 hover:border-gold"}`}>
            {p}"
          </button>
        ))}
      </div>
      {ratio ? (
        <label className="mt-4 flex items-center gap-3 text-sm font-semibold text-slate-300">
          <Switch checked={lock} onCheckedChange={setLock} data-testid="lock-ratio-switch" /> {t("builder.lock")}
        </label>
      ) : null}
      <p className={`mt-3 text-xs ${error ? "font-bold text-ruby" : "text-slate-500"}`} data-testid="size-limits">
        {error ? t(`errors.size_out_of_range_${type}`) : t(`builder.limits_${type}`)}
      </p>
    </div>
  );
};
